import { defineStore } from 'pinia'
import RegisterStore, { RegisterState } from '@/modules/register/types/store/RegisterStore'
import {
  CountryItemI,
  CountryListI,
  CountrySelectOptionI,
  CurrenciesItemI,
} from '@/modules/register/types/api/RegisterUser'
import CurrencyItem from '@/modules/register/entities/CurrencyItem'
import CountryItem from '@/modules/register/entities/CountryItem'
import UserToken from '@/entities/security/UserToken'
import { TokenManager } from '@/entities/security/TokenManager'
import { useUserStore } from '@/modules/auth/store'

const tokenManager = new TokenManager()
export const useRegisterStore: RegisterStore = defineStore('register', {
  state: () =>
    ({
      currencyList: [],
      countriesList: [],
      checkoutRegisterPayload: null,
    }) as RegisterState,
  getters: {
    currenciesSelectList(state) {
      return (
        state.currencyList?.map((item: CurrenciesItemI) => {
          return {
            title: item.code,
            value: item.id,
          }
        }) ?? []
      )
    },
    countriesSelectList(state): CountrySelectOptionI[] {
      return (
        state.countriesList?.map((item: CountryItemI) => {
          return {
            title: item.name,
            value: item.key,
          }
        }) ?? []
      )
    },
    countriesPhoneCodesList(state) {
      return (
        state.countriesList?.map((item: CountryItemI) => {
          return {
            title: item.name,
            value: '' + item.callingCode,
            inputTitle: `+${item.callingCode}`,
            rightLabel: `+${item.callingCode}`,
          }
        }) ?? []
      )
    },
    getCheckoutRegisterPayload(state) {
      return state.checkoutRegisterPayload
    },
    getDefaultCountry(state): CountryItemI | null {
      const DEFAULT_COUNTRY_TITLE = 'Sweden'

      return state.countriesList.find(country => country.name === DEFAULT_COUNTRY_TITLE) ?? null
    },
    getDefaultCurrencyId(state) {
      return state.currencyList[0].id
    },
  },
  actions: {
    async registerUser(data) {
      const response = await this.$services.register.registerUser(data)
      if (response instanceof Error) {
        return response
      }
      tokenManager.createUserAccess(new UserToken(response.token))
      await useUserStore().loadUser()
    },
    async checkoutRegisterUser(data) {
      const response = await this.$services.register.registerUser(data)
      tokenManager.createUserAccess(new UserToken(response.token))
      return response
    },
    async getCurrenciesList() {
      const response = await this.$services.register.loadCurrenciesList()
      if (response instanceof Error) {
        return response
      }
      if (response.currencies) {
        this.currencyList = response.currencies.currency.map((item: CurrenciesItemI) => new CurrencyItem(item))
      }
    },
    async getCountriesList() {
      const response: CountryListI | Error = await this.$services.register.loadCountriesList()
      if (response instanceof Error) {
        return response
      }
      this.countriesList = Object.keys(response.countries).map((key: string) => {
        return new CountryItem({
          ...response.countries[key],
          key: key,
        })
      })
    },
    updateCheckoutRegisterPayload(payload) {
      this.checkoutRegisterPayload = payload
    },
  },
})
